/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Rules_TitleInputs */

const en_directory_submit_rules_title = /** @type {(inputs: Directory_Submit_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you submit`)
};

const zh_directory_submit_rules_title = /** @type {(inputs: Directory_Submit_Rules_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交前请了解`)
};

/**
* | output |
* | --- |
* | "Before you submit" |
*
* @param {Directory_Submit_Rules_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_rules_title = /** @type {((inputs?: Directory_Submit_Rules_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Rules_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_rules_title(inputs)
	return zh_directory_submit_rules_title(inputs)
});
export { directory_submit_rules_title as "directory.submit.rules_title" }